 // Email and phone number labels
$(document).ready(function () {
  function handleContactLinks() {
    $('a[href^="mailto:"], a[href^="tel:"]').each(function () {
      var $link = $(this);
      var href = $link.attr('href');
      var linkText = $.trim($link.text());

      if (href.startsWith('mailto:')) {
        $link.attr('aria-label', 'Email Address: ' + linkText);
      } else if (href.startsWith('tel:')) {
        // remove Tel: or Phone:
        linkText = linkText.replace(/^(Tel:|Phone:)\s*/i, '');
        $link.attr('aria-label', 'Phone number: ' + linkText);
      }
    });
  }

  handleContactLinks();
});


//  br tag hide
 $(document).ready(function(){
  $("br").attr("aria-hidden", "true");
  $(".menu__item.grandparent a.navlink--toplevel").attr("aria-expanded", "false");

});

//  hr tag hide
 $(document).ready(function(){
  $("hr").attr("aria-hidden", "true");
});

// Accessibility Enhancements for Third-Party Links
$(document).ready(function () {
  var excludedLinks = []; 

  function isThirdParty(url) {
    try {
      var linkHost = new URL(url, window.location.origin).hostname;
      var currentHost = window.location.hostname;
      return linkHost && linkHost !== currentHost;
    } catch (e) {
      return false;
    }
  }

  function handleExternalLinks() {
    $("a").each(function () {
      var $link = $(this);
      var href = $link.attr("href");

      // ← SKIP OKENDO LINK (NO CLASS NEEDED)
      if (
        !href ||
        !isThirdParty(href) ||
        excludedLinks.includes(href) ||
        href.includes("okendo.reviews") ||     // 🔥 IMPORTANT SKIP
        $link.hasClass("oke-w-writeReview")    // 🔥 OPTIONAL EXTRA SKIP
      ) return;

      // Always open in new tab
      $link.attr("target", "_blank");
      $link.attr("rel", "noopener noreferrer");

      if (!$link.attr("aria-label")) {
        var existingText = $.trim($link.text());
        var ariaLabel = existingText
          ? existingText + ", This link will open in a new tab"
          : "This link will open in a new tab";
        $link.attr("aria-label", ariaLabel);
      }

      var $img = $link.find("img, svg").first();
      if ($img.length && !$img.attr("alt")) {
        $img.attr("alt", "This link will open in a new tab");
      }
    });
  }

  handleExternalLinks();

  var observer = new MutationObserver(function () {
    handleExternalLinks();
  });
  observer.observe(document.body, { childList: true, subtree: true });
});

// remove tab-index from slideshow wrapper
$(document).ready(function() {
  $('.slideshow__wrapper').removeAttr('tabindex');
});


// empty elements removal heading and strong tags
$(document).ready(function () {

    // // Remove empty <strong>
    // $('strong').each(function () {
    //     if ($(this).text().trim() === '') {
    //         $(this).remove();
    //     }
    // });

    // Remove ONLY truly empty headings
    $('h1, h2, h3, h4, h5, h6').each(function () {
        const $h = $(this);

        // Skip if heading contains any image
        if ($h.find('img').length > 0) return;

        // Get text (excluding child tags)
        const text = $h.text().trim();

        // Check if all children are empty span or <br aria-hidden>
        const onlyEmptyChildren = $h.children().filter(function () {
            const tag = this.tagName.toLowerCase();

            // allowed empty tags
            if (tag === 'span' && $(this).text().trim() === '') return false;
            if (tag === 'br' && $(this).attr('aria-hidden') === 'true') return false;

            // anything else = not empty
            return true;
        });

        // If text empty AND no unwanted children → remove
        if (text === '' && onlyEmptyChildren.length === 0) {
            $h.remove();
        }
    });

});




// search popup accessibility improvements
// $(document).on("keydown", function (e) {
//     if (e.key === "Escape") {

//         e.preventDefault();
//         e.stopImmediatePropagation(); 
//         e.stopPropagation();

//         setTimeout(function () {
//             $("#un").focus();
//         }, 20);
//     }
// });

// $(document).on("click", "[data-close-popdown]", function () {
//     setTimeout(function () {
//         $("#un").focus();
//     }, 10);
// });

// // excape press to focus back to search button
(function(){
  var $btn = $("#un");
  var popup = document.getElementById("search-popdown");
  if (!popup) return;
  var mo = new MutationObserver(function(m){
    if (!popup.classList.contains("is-visible")) {
      setTimeout(function(){ $btn.focus(); }, 0);
    }
  });
  mo.observe(popup, { attributes: true, attributeFilter: ["class"] });
})();






// remove overflow hidden back when cart is closed
$(document).ready(function() {
    var $body = $('body');

    // Check every 100ms if cart class is removed
    setInterval(function() {
        if (!$body.hasClass('rebuy-cart-visible') && $body.css('overflow') === 'hidden') {
            $body.css('overflow', ''); // remove overflow hidden
        }
    }, 100);
});

// svg accessibility - hide from screen readers
$(document).ready(function () {
    $("svg").each(function () {
        const hasTitle = $(this).find("title").length > 0;
        const hasAriaLabel = $(this).attr("aria-label");
        const hasAriaLabelledBy = $(this).attr("aria-labelledby");
        const isImageRole = $(this).attr("role") === "img";

        if (!hasTitle && !hasAriaLabel && !hasAriaLabelledBy && !isImageRole) {
            $(this).attr("aria-hidden", "true");
        }
    });
});




// slider accessibility improvements for flickity dots and live region
// $(document).ready(function () {

//   // Live region create only once
//   if ($('#dot-status-live').length === 0) {
//     $('.flickity-page-dots').after(
//       '<div id="dot-status-live" class="visually-hidden" aria-live="polite" aria-atomic="true"></div>'
//     );
//   }

//   function updateDots() {
//     const dots = $('.flickity-page-dots .dot');
//     const total = dots.length;

//     dots.each(function (index) {
//       const $dot = $(this);
//       const isSelected = $dot.hasClass('is-selected');

//       // Update aria-label
//       $dot.attr('aria-label', `slide ${index + 1} of ${total}`);

//       // Update aria-selected
//       $dot.attr('aria-selected', isSelected ? 'true' : 'false');

//       // Role
//       $dot.attr('role', 'button');

//       // Announce ONLY if this dot is selected
//       if (isSelected) {
//         $('#dot-status-live').text(`Slide ${index + 1} selected`);
//       }
//     });
//   }

//   // Initial run
//   updateDots();

//   // Update when Flickity changes slide
//   $(document).on('change.flickity', function () {
//     updateDots();
//   });

//   // Update when dots clicked
//   $(document).on('click', '.flickity-page-dots .dot', function () {
//     setTimeout(updateDots, 30);
//   });

// });




// add tab-index to slideshow slides based on visibility
$(document).ready(function () {
  function updateAccessibility() {
    $('.slideshow__slide').each(function () {
      if ($(this).attr('aria-hidden') === 'true') {
       
        $(this).find('a, button, input, select, textarea').attr('tabindex', '-1');
      } else {
  
        $(this).find('a, button, input, select, textarea').removeAttr('tabindex');
      }
    });
  }

  // Initial update
  updateAccessibility();

  // Agar aapka slideshow JS koi event fire karta hai slide change par, us event me ye call karo
  // Example Flickity ke liye:
  $('.slideshow__wrapper').on('change.flickity', function () {
    updateAccessibility();
  });
});

// remove aria-hidden from slick slides and press titles
$(document).ready(function() {
    $('.slick-slide[aria-hidden="true"], .slick-slide[aria-hidden="false"]').removeAttr('aria-hidden');
    $('.background-size-cover.press-title[aria-hidden="true"]').removeAttr('aria-hidden');
});


// remove link over image in hero sections empty links
$(document).ready(function () {

    $('.brick__block__image.text--white > .hero__content__wrapper.align--middle-center > a.link-over-image').remove();

});





// Accessibility update aria-selected and aria-label on grid view toggle buttons
jQuery(document).ready(function ($) {

  var $grid = $('.js-grid');
  var $buttons = $("[data-toggle-grid]");

  function updateAria(current) {
    $buttons.each(function () {
      var $btn = $(this);
      var num = $btn.data("toggle-grid");

      if (num == current) {
        $btn.attr("aria-label", "Selected, show " + num + " products per row");
      } else {
        $btn.attr("aria-label", "Show " + num + " products per row");
      }
    });
  }

  // On page load — read current from data-grid-large
  var defaultGrid = $grid.data('grid-large');
  updateAria(defaultGrid);

  // On click — use clicked value, NOT data-grid-large
  $buttons.on("click", function () {
    var num = $(this).data("toggle-grid");  // clicked value
    $grid.attr("data-grid-large", num);     // update container
    updateAria(num);                        // update aria live
  });

});


// // stop the auto play slider on page
// jQuery(document).ready(function ($) {

//   // Kill all timers Replo may create
//   const killTimers = () => {
//     for (let i = 1; i < 99999; i++) {
//       clearInterval(i);
//       clearTimeout(i);
//     }
//   };

//   killTimers();
//   setTimeout(killTimers, 1000);
//   setInterval(killTimers, 2000); // Keep killing any new timers

//   // FULL HARD BLOCK – override autoplay function
//   const stopReploAutoplay = () => {
//     if (window.Replo && window.Replo.Carousel) {
//       window.Replo.Carousel.prototype.autoPlay = function () {
//         return false; // Disable autoplay completely
//       };
//       window.Replo.Carousel.prototype.startAutoplay = function () {
//         return false;
//       };
//       window.Replo.Carousel.prototype.initAutoplay = function () {
//         return false;
//       };
//     }
//   };

//   stopReploAutoplay();
//   setTimeout(stopReploAutoplay, 1500);
//   setInterval(stopReploAutoplay, 2000); // reblock if replo reloads
// });


// pagination accessibility - current page live region
$(document).ready(function () {
  const $active = $('.pagination-custom__num.active');

  if ($active.length) {
    const page = $.trim($active.text());
    $('#pagination-live').text('Current page ' + page);
  }
});



// remove aria-hidden and tabindex from product thumbs
document.addEventListener('DOMContentLoaded', function() {
    // Find the thumbs wrapper
    var thumbsWrapper = document.querySelector('[data-product-thumbs]');
    if (!thumbsWrapper) return;

    // Function to remove aria-hidden and tabindex
    function cleanAttributes(node) {
        if (node.nodeType === 1) { // Element node
            if (node.hasAttribute('aria-hidden')) node.removeAttribute('aria-hidden');
            if (node.hasAttribute('tabindex')) node.removeAttribute('tabindex');
        }
    }

    // Clean the parent wrapper first
    cleanAttributes(thumbsWrapper);

    // Clean all existing children
    thumbsWrapper.querySelectorAll('.media__thumb').forEach(cleanAttributes);

    // Observe future changes in children
    var observer = new MutationObserver(function(mutationsList) {
        mutationsList.forEach(function(mutation) {
            mutation.addedNodes.forEach(cleanAttributes);
            if (mutation.type === 'attributes' && (mutation.attributeName === 'aria-hidden' || mutation.attributeName === 'tabindex')) {
                cleanAttributes(mutation.target);
            }
        });
    });

    observer.observe(thumbsWrapper, { 
        childList: true, 
        subtree: true, 
        attributes: true, 
        attributeFilter: ['aria-hidden', 'tabindex'] 
    });
});


// remove tabindex from product slideshow wrapper
document.addEventListener("DOMContentLoaded", function () {
    function removeSlideShowTabIndex() {
        document
            .querySelectorAll("[data-product-slideshow]")
            .forEach(el => el.removeAttribute("tabindex"));
    }

    // Run initially
    removeSlideShowTabIndex();

    // Observe target specifically
    document.querySelectorAll("[data-product-slideshow]").forEach(slideshow => {
        const obs = new MutationObserver(mutations => {
            mutations.forEach(m => {
                if (m.type === "attributes" && m.attributeName === "tabindex") {
                    m.target.removeAttribute("tabindex");
                }
            });
            removeSlideShowTabIndex();
        });

        obs.observe(slideshow, {
            attributes: true,
            attributeFilter: ["tabindex"]
        });
    });
});

 // add role list to flickity thumbnail wrapper
$(window).on("load", function () {

  function addRole() {
    var $slider = $('.media__thumb__wrapper .flickity-slider');
    if ($slider.length && !$slider.attr("role")) {
      $slider.attr('role', 'list');
    }
  }

  // Run once
  addRole();

  // Run again if DOM changes (Flickity updates)
  const obs = new MutationObserver(addRole);
  obs.observe(document.body, { childList: true, subtree: true });
});



// focus management for mobile menu drawer
$(document).ready(function() {
    // When the close button inside the drawer is clicked
    $('.drawer__button.drawer__close').on('click', function() {
        // Return focus to the mobile menu button
        $('.header__mobile__button[data-drawer-toggle="hamburger"]').focus();
    });
});



// aria-expanded management for mobile menu drawer
$(document).ready(function () {
    const menuBtn = $('.header__mobile__button[data-drawer-toggle="hamburger"]');
    const drawer = $('#header-menu');

    // Close button click
    $('.drawer__close').on('click', function () {
        // Focus back
        menuBtn.focus();

        // Force aria-expanded false
        menuBtn.attr('aria-expanded', 'false');
    });

    // ALSO: observe drawer visibility changes
    const observer = new MutationObserver(function () {
        const isOpen = drawer.hasClass('drawer--visible');

        if (!isOpen) {
            // Drawer is closed → fix aria-expanded
            menuBtn.attr('aria-expanded', 'false');
        }
    });

    observer.observe(drawer[0], {
        attributes: true,
        attributeFilter: ['class']
    });
});




// remove aria-haspopup and aria-expanded from mobile menu buttons
$(document).ready(function() {
    // Check if mobile device
    function isMobile() {
        return window.innerWidth <= 768;
    }
    
    // Remove attributes from buttons on mobile
    function removeMobileAttributes() {
        if (isMobile()) {
            $('button[aria-haspopup="true"][aria-expanded="false"]').each(function() {
                $(this).removeAttr('aria-haspopup');
                $(this).removeAttr('aria-expanded');
                $(this).removeAttr('aria-controls');
                $(this).removeAttr('data-sliderule-open');
            });
        }
    }
    
    // Run on page load
    removeMobileAttributes();
    
    // Run on window resize
    $(window).resize(function() {
        removeMobileAttributes();
    });
});





$(document).ready(function () {
    if (typeof jQuery === "undefined") {
        console.error("jQuery not loaded");
        return;
    }

    let lastTriggerButton = null;

    //-------------------------------
    // When submenu OPEN button clicked
    //-------------------------------
    $(document).on("click", '.sliderow[aria-label*="Open"]', function () {
        console.log("Submenu opener clicked");

        lastTriggerButton = $(this); // Save the opener

        // Panel ID from aria-label: "Open,New,submenu"
        // Not needed because Shopify shows the panel automatically.

        setTimeout(() => {
            let visiblePanel = $(".sliderule__panel.is-visible");
            let backButton = visiblePanel.find('[data-sliderule-close]');

            if (backButton.length) {
                backButton.focus();
                console.log("Focus moved to BACK button");
            }
        }, 300);
    });

    //-------------------------------
    //  When BACK button is clicked
    //-------------------------------
    $(document).on("click", '[data-sliderule-close]', function () {
        console.log("Back button clicked");

        if (lastTriggerButton && lastTriggerButton.length) {
            setTimeout(() => {
                lastTriggerButton.focus();
                console.log("Focus returned to opener");
            }, 150);
        }
    });
});

// remove top-level link href if dropdown exists
$(document).ready(function () {
  $('.menu__item').each(function () {
    var hasDropdown = $(this).find('.header__dropdown').length > 0;
    var topLink = $(this).find('> a.navlink--toplevel');

    if (hasDropdown) {
      // remove href + add role button
      topLink.removeAttr('href')
             .attr('role', 'button')
             .css('cursor', 'pointer');
    }
  });
});






$(document).ready(function () {

  const ACTIVE = "is-visible";

  // ----------------------------
  // Toggle dropdown on click
  // ----------------------------
  $(document).on("click", ".menu__item.grandparent", function (e) {
    e.stopPropagation();

    const $item = $(this);
    const $dropdown = $item.find(".header__dropdown");

    const isOpen = $item.hasClass(ACTIVE);

    // Close all others
    $(".menu__item.grandparent").not($item).removeClass(ACTIVE)
      .find(".header__dropdown").removeClass(ACTIVE).hide();

    $(".menu__item.grandparent").not($item)
      .find("a.navlink--toplevel").attr("aria-expanded", "false");

    // Toggle current
    if (isOpen) {
      $item.removeClass(ACTIVE);
      $dropdown.removeClass(ACTIVE).hide();
      $item.find("a.navlink--toplevel").attr("aria-expanded", "false");

    } else {
      $item.addClass(ACTIVE);
      $dropdown.addClass(ACTIVE).show();
      $item.find("a.navlink--toplevel").attr("aria-expanded", "true");
    }
  });

  // --------------------------------
  // Close when clicking outside
  // --------------------------------
  $(document).on("click", function (e) {
    if (!$(e.target).closest(".menu__item.grandparent").length) {
      $(".menu__item.grandparent").removeClass(ACTIVE)
        .find(".header__dropdown").removeClass(ACTIVE).hide();

      $(".menu__item.grandparent a.navlink--toplevel")
        .attr("aria-expanded", "false");
    }
  });

  // --------------------------------
  // Touch support (tablets)
  // --------------------------------
  $(document).on("touchstart", ".menu__item.grandparent", function (e) {
    if (!$(this).hasClass(ACTIVE)) {
      e.preventDefault(); // open first tap
      $(this).trigger("click");
    }
  });

});


// remove arrow span if no dropdown exists
$(document).ready(function() {
    $('.menu__item').each(function() {
        const $menuItem = $(this);
        const $navLink = $menuItem.find('.navlink--toplevel');
        const $arrowSpan = $menuItem.find('.arr');
        if ($navLink.length && !$navLink.attr('aria-expanded')) {
            $arrowSpan.remove();
        }
    });
});


// excape focus managaement for desktop dropdown
$(document).ready(function() {
  // Cache the hamburger (menu open) button
  var $menuToggle = $('[data-drawer-toggle="hamburger"]');

  // Function to focus back to menu button
  function focusBackToMenuButton() {
    setTimeout(function() {
      $menuToggle.trigger('focus');
    }, 150); // small delay ensures animations complete
  }

  // Close all open dropdowns
  function closeAllMenus() {
    $('.navlink--toplevel').attr('aria-expanded', 'false');
    $('click-disclosure').attr('aria-expanded', 'false');
    $('.header__dropdown').hide().removeClass('is-visible');
  }

  // Desktop: Escape key closes any open dropdowns
  $(document).keydown(function(e) {
    if (e.key === "Escape") {
      var $openMenu = $('[aria-expanded="true"]').filter('.navlink--toplevel');
      if ($openMenu.length > 0) {
        closeAllMenus();
        $openMenu.trigger('focus'); // optional: return focus to the menu item
      }
    }
  });

 // Desktop: Toggle dropdown on top-level nav click (link stays clickable)
$('.navlink--toplevel').on('click', function (e) {
  var $this = $(this);
  var $parentDisclosure = $this.closest('click-disclosure');
  var $dropdown = $parentDisclosure.find('.header__dropdown');
  var isExpanded = $this.attr('aria-expanded') === 'true';

  // If there is NO dropdown, let the link work normally
  if (!$dropdown.length) return;

  // If dropdown is already open, allow normal navigation (link clickable)
  if (isExpanded) return;

  // First click: open dropdown and prevent navigation
  e.preventDefault();

  closeAllMenus();

  $this.attr('aria-expanded', 'true');
  $parentDisclosure.attr('aria-expanded', 'true');
  $dropdown.show().addClass('is-visible');
});


  // Mobile: Close button focuses back to hamburger
  $(document).on('click', '[data-drawer-close][aria-controls="header-menu"]', function() {
    focusBackToMenuButton();
  });
});


// aria-expanded attribute manage for without dropdown on
$(document).ready(function () {

    function cleanNonDropdownAria() {
        $('.menu__item').each(function () {

            // Check if this menu item contains a dropdown
            var hasDropdown = $(this).find('.header__dropdown').length > 0;

            // If NO dropdown → remove aria-expanded from the LINK
            if (!hasDropdown) {
                $(this).find('a[aria-expanded]').removeAttr('aria-expanded');
            }
        });
    }

    // Run once at load
    cleanNonDropdownAria();

    // MutationObserver to keep cleaning on DOM updates
    const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {

            // Only clean when aria-expanded attribute is added or changed
            if (mutation.type === "attributes" &&
                mutation.attributeName === "aria-expanded") {

                cleanNonDropdownAria();
            }
        });
    });

    // Observe only menu, not whole page (no lag)
    const target = document.querySelector('.menu') || document.querySelector('.header__menu');

    if (target) {
        observer.observe(target, {
            subtree: true,
            attributes: true,
            attributeFilter: ["aria-expanded"]
        });
    }

});






// search dropdown management popup
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll("[data-no-dropdown]").forEach(el => {
    el.removeAttribute("data-hover-disclosure-toggle");
    el.removeAttribute("aria-haspopup");
    el.removeAttribute("aria-controls");
  });
});

// remove target _blank from internal links
$(document).ready(function() {

    var baseURL = 'https://houseofintuitionla.com';

    $('a[target="_blank"]').each(function() {
        var href = $(this).attr('href');


        if (href && href.startsWith(baseURL)) {
            $(this).removeAttr('target'); 
        }
    });
});


// Fix aria-label by appending dynamic button text for accessibility
 $(document).ready(function () {
    $('.link-over-image').each(function () {
      var $link = $(this);

      // existing aria-label (collection title)
      var ariaLabel = $link.attr('aria-label') || '';

 
      var buttonText = $link.find('.hero__btn').text().trim();

      if (buttonText && !ariaLabel.includes(buttonText)) {
        $link.attr('aria-label', ariaLabel + ' ' + buttonText);
      }
    });
  });
// add aria-selected attribute on tab
  $(document).ready(function () {
  $('.slick-dots li button').attr('aria-selected', 'false');
  $('.slick-dots li.slick-active button').attr('aria-selected', 'true');
});
